// The three runtime-owned OAuth SYSTEM methods — the frozen v1 seam. Do not rename: these are published
// method names the platform invokes by string.
export const OAUTH_SYSTEM_METHODS = {
  CONNECTION_URL: 'getOAuth2ConnectionURL',
  EXECUTE_CALLBACK: 'executeCallback',
  REFRESH_TOKEN: 'refreshToken',
} as const
